module.exports = __webpack_public_path__ + "img/interPersonal3.bbce40c9.png";